<template>
  <div @click="showlan = false;if(showyy) $refs.booking.closeSelect();if(active == 5) $refs.section7.closeSelect2()">
    <div class="navs">
      <div class="nav_left">
        <div class="logo"></div>
        <ul>
          <li @click="changeSwiper(0)">
            <img v-if="active == 0 || active == 1"
              :src="require(`../assets/${language}/1/nav1_active.png`)" alt="">
            <img v-else :src="require(`../assets/${language}/1/nav1.png`)" alt="">
          </li>
          <li @click="changeSwiper(2)">
            <img v-if="active == 2" :src="require(`../assets/${language}/1/nav2_active.png`)" alt="">
            <img v-else :src="require(`../assets/${language}/1/nav2.png`)" alt="">
          </li>
          <li @click="changeSwiper(3)">
            <img v-if="active == 3" :src="require(`../assets/${language}/1/nav3_active.png`)" alt="">
            <img v-else :src="require(`../assets/${language}/1/nav3.png`)" alt="">
          </li>
          <li @click="changeSwiper(4)">
            <img v-if="active == 4" :src="require(`../assets/${language}/1/nav4_active.png`)" alt="">
            <img v-else :src="require(`../assets/${language}/1/nav4.png`)" alt="">
          </li>
        </ul>
      </div>
      <div class="nav_right">
        <div class="logout" @click="logout" v-if="isLogin && !menu">{{ i18n('logout') }}</div>
        <a :class="['ljyy',language]" href="https://chuang-games.com/recharge/133?regionId=33" target="_blank">{{i18n('czyh')}}</a>
        <a class="youtube" href="https://forum.gamer.com.tw/B.php?bsn=84025" target="_blank"><i></i></a>
        <a class="discord" href="https://discord.gg/VxzTeYJYzm" target="_blank" title="discord"><i></i></a>
        <a class="fanpage" href="https://www.facebook.com/CrossGateAdventureTW/" target="_blank" title="facebook"><i></i></a>
        <!-- <div :class="['language-select',{'open':showlan},language]" @click.stop="showlan = !showlan;menu = false">
          <span v-if="language == 'zh'">简中</span>
          <span v-else-if="language == 'tw'">繁中</span>
          <span v-else-if="language == 'en'">EN</span>
          <span v-else-if="language == 'in'">Indonesia</span>
          <span v-else-if="language == 'th'">ภาษาไทย</span>
          <span v-else-if="language == 'fi'">Filipino</span>
        </div> -->
        <div :class="['menu',{'open':menu}]" @click="menu = !menu"></div>
      </div>
      <transition name="fade">
        <ul class="language-options" v-if="showlan">
          <li :class="['option',{'active': language == 'zh'}]" @click="changeLanguage('zh')">简体中文</li>
          <li :class="['option',{'active': language == 'tw'}]" @click="changeLanguage('tw')">繁体中文</li>
          <li :class="['option',{'active': language == 'en'}]" @click="changeLanguage('en')">English</li>
          <!-- 印尼语 -->
          <li :class="['option',{'active': language == 'in'}]" @click="changeLanguage('in')">Indonesia</li>
          <!-- 泰语 -->
          <li :class="['option',{'active': language == 'th'}]" @click="changeLanguage('th')">ภาษาไทย</li>
          <!-- 菲律宾语 -->
          <li :class="['option',{'active': language == 'fi'}]" @click="changeLanguage('fi')">Filipino</li>
        </ul>
      </transition>
      <transition name="fade">
        <div class="menu_area" v-if="menu">
          <div class="menu_bg"></div>
          <ul class="menu_options">
            <li @click="menu = false;changeSwiper(0)">
              <img v-if="active == 0 || active == 1"
                :src="require(`../assets/${language}/1/nav1_active.png`)" alt="">
              <img v-else :src="require(`../assets/${language}/1/nav1.png`)" alt="">
            </li>
            <li @click="menu = false;changeSwiper(2)">
              <img v-if="active == 2" :src="require(`../assets/${language}/1/nav2_active.png`)" alt="">
              <img v-else :src="require(`../assets/${language}/1/nav2.png`)" alt="">
            </li>
            <li @click="menu = false;changeSwiper(3)">
              <img v-if="active == 3" :src="require(`../assets/${language}/1/nav3_active.png`)" alt="">
              <img v-else :src="require(`../assets/${language}/1/nav3.png`)" alt="">
            </li>
            <li @click="menu = false;changeSwiper(4)">
              <img v-if="active == 4" :src="require(`../assets/${language}/1/nav4_active.png`)" alt="">
              <img v-else :src="require(`../assets/${language}/1/nav4.png`)" alt="">
            </li>
          </ul>
        </div>
      </transition>
    </div>

    <swiper :options="swiperOption" ref="swiper">
      <swiper-slide class="slide1">
        <section1 :i18n="i18n" :language="language" @openvideo="openvideo" @showYq="showYq" @ljyy="ljyy" @openFlLogin="openFlLogin"/>
      </swiper-slide>
      <!-- <swiper-slide class="slide2">
        <section2 :i18n="i18n" :language="language" ref="section2" @ljyy="ljyy" />
      </swiper-slide> -->
      <swiper-slide class="slide3">
        <section3 :i18n="i18n" :language="language" :lottery_chances.sync="lottery_chances" :showWin.sync="showWin" :win_name.sync="win_name"
          :showSw.sync="showSw" :log_id.sync="log_id" @getTaskList="getTaskList" ref="section3"
          @checkLoginAndExecute="checkLoginAndExecute" @openRule="showrule2 = true" />
      </swiper-slide>
      <swiper-slide class="slide4">
        <section4 :i18n="i18n" :language="language" ref="section4" @openNewsDetail="getNewsDetail" />
      </swiper-slide>
      <swiper-slide class="slide5">
        <section5 :i18n="i18n" :language="language" ref="section5" />
      </swiper-slide>
      <swiper-slide class="slide6">
        <section6 :i18n="i18n" :language="language" ref="section6" />
      </swiper-slide>
      <swiper-slide class="slide7">
        <section7 :i18n="i18n" :language="language" @openyySuccess="openyySuccess" ref="section7" />
      </swiper-slide>
    </swiper>


    <!-- video弹框 -->
    <div class="pop_bg video_pop" v-if="showvideo">
      <div class="video_area">
        <div class="close" @click="closevideo"></div>
        <!-- <div class="play" v-show="!isPlaying" @click="togglePlay"></div> -->
        <iframe ref="video" :id="'youtube-player-' + Date.now()" width="100%" height="100%"
          :src="`https://www.youtube.com/embed/wKm60RPCV9U?enablejsapi=1&autoplay=1&mute=1&controls=0&rel=0&loop=1&playlist=wKm60RPCV9U&playsinline=1`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen @load="onVideoLoad">
        </iframe>
        <!-- <video ref="video" src="https://www.youtube.com/embed/4BZ3s0bLHx0?autoplay=1&mute=1&controls=0" poster="../assets/zh/1-1/pv.png"
          @play="onVideoPlay" @pause="onVideoPause" @ended="onVideoEnded" @click="togglePlay"></video> -->
      </div>
    </div>
    <!-- 邀请好友弹框 -->
    <div class="pop_bg yq_pop yq_pop2" v-if="showyq">
      <div class="yq_area">
        <div class="close" @click="showyq = false"></div>
        <img class="title" :src="require(`../assets/${language}/1-3/title.png`)" alt="">
        <div class="rewards" :style="{'backgroundImage': `url(${require(`../assets/${language}/1-3/reward_bg.png`)})`}">
          <div class="wap"
            :style="{'backgroundImage': `url(${require(`../assets/wap/${language}/1-6/reward_bg.png`)})`}"></div>
          <ul>
            <li>
              <span>{{ i18n('invite1') }}</span>
            </li>
            <li>
              <span>{{ i18n('invite2') }}</span>
            </li>
            <li>
              <span>{{ i18n('invite3') }}</span>
            </li>
          </ul>
          <div class="nums">
            {{ i18n('members') }}:
            <div class="nums_area">{{team_num}}/3</div>
          </div>
          <div class="rule rule_btn" @click="showrule = true" style="display:none">*&nbsp;{{ i18n('eventRules') }}</div>
          <div class="record_btn" @click="getInvitationCdkRewards">*&nbsp;{{ i18n('rewards') }}</div>
        </div>
        <div class="btns">
          <div class="btn btn1" @click="inviteFriends">{{ i18n('inviteFriends') }}</div>
          <div class="btn btn2" @click="$message.error('活動已結束')">{{ i18n('joinTeam') }}</div>
        </div>
        <div class="rule" @click="showrule = true"><i></i>{{ i18n('eventRules') }}</div>
      </div>
    </div>
    <!-- 邀请好友奖励弹框 -->
    <div class="pop_bg yq_pop yqhy_pop" v-if="showjljl1">
      <div class="yq_area">
        <div class="close" @click="showjljl1 = false"></div>
        <!-- <img class="title" :src="require(`../assets/${language}/jljl/jljl.png`)" alt=""> -->
        <div class="rewards rewards2">
          <div class="jljl">
            <p v-for="(item,i) in cdkRewards" :key="i">
              {{ i+1 }}.&nbsp;&nbsp;&nbsp;{{ item.cdk_code }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 邀请好友规则弹框 -->
    <div class="pop_bg rule_pop" v-if="showrule">
      <div class="rule_area">
        <div class="close" @click="showrule = false"></div>
        <div class="cont cont2" v-html="i18n('rule')"></div>
      </div>
    </div>
    <!-- 抽奖规则弹框 -->
    <div class="pop_bg rule_pop" v-if="showrule2">
      <div class="rule_area">
        <div class="close" @click="showrule2 = false"></div>
        <div class="cont">
          <p class="title">{{ i18n('drawrule') }}</p>
          <div v-html="i18n('rule2')"></div>
        </div>
      </div>
    </div>
    <!-- 登录弹框 -->
    <div class="pop_bg login_pop" v-if="showlogin">
      <div class="login_area">
        <div class="close" @click="showlogin = false"></div>
        <div class="logo"></div>
        <a class="apple" href="javascript:;" @click="loginApple">
          <img :src="require(`../assets/zh/1-4/apple.png`)" alt="">
        </a>
        <a class="google" href="javascript:;" @click="loginGoogle">
          <img :src="require(`../assets/zh/1-4/google.png`)" alt="">
        </a>
        <a class="facebook" href="javascript:;" @click="loginFacebook">
          <img :src="require(`../assets/zh/1-4/facebook.png`)" alt="">
        </a>
      </div>
    </div>

    <!-- 加入团队弹框  -->
    <div class="pop_bg login_pop join_pop" v-if="showJoin">
      <div class="login_area join_area">
        <div class="close" @click="showJoin = false"></div>
        <div class="logo"></div>
        <img class="title" :src="require(`../assets/${language}/1-5/tit.png`)" alt="">
        <a class="join_btn" href="javascript:;">{{ i18n('submit') }}</a>
      </div>
    </div>

    <!-- 邀请好友弹框 -->
    <div class="pop_bg login_pop join_pop invite_pop" v-if="showInvite">
      <div class="login_area join_area invite_area">
        <div class="close" @click="showInvite = false"></div>
        <div class="logo"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/1-6/tit_6.png`)" alt="">
        <a class="join_btn invite_btn" href="javascript:;" @click="copyInviteLink">{{ i18n('copyInfo') }}</a>
      </div>
    </div>

    <!-- 加入团队弹框 组队邀请码 -->
    <div class="pop_bg login_pop join_pop invite_pop join_code_pop" v-if="showJoinCode">
      <div class="login_area join_area invite_area join_code_area">
        <div class="close" @click="showJoinCode = false;team_code = ''"></div>
        <div class="logo"></div>
        <input type="text" :placeholder="i18n('enterTeamCode')" class="team_code" v-model="team_code">
        <a class="join_btn" href="javascript:;" @click="joinGroup">{{ i18n('submit') }}</a>
      </div>
    </div>

    <!-- 预约弹框 -->
    <div class="pop_bg yq_pop yy_pop" v-if="showyy">
      <div :class="['yq_area','yy_area',language]">
        <div class="close" @click="showyy = false"></div>
        <img class="title" :src="require(`../assets/${language}/1-8/tit_8.png`)" alt="">
        <div class="rewards">
          <booking :action="1" :i18n="i18n" @openyySuccess="openyySuccess" ref="booking"/>
        </div>
      </div>
    </div>
    <!-- 预约成功弹框 -->
    <div class="pop_bg yy_success_pop" v-if="showyySuccess">
      <div class="yy_success_area">
        <div class="close" @click="showyySuccess = false"></div>
        <p class="p1"></p>
        <img :class="['p2',language]" :src="require(`../assets/${language}/1-9/1_9_text.png`)" alt="">
        <p class="p3" @click="showyySuccess = false;showyy = false">{{i18n('confirm')}}</p>
      </div>
    </div>

    <!-- 获取抽奖次数弹框 -->
    <div class="pop_bg yq_pop chance_pop" v-if="showTask">
      <div class="yq_area yy_area chance_area">
        <div class="close" @click="showTask = false"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/3-2/3_2-tit.png`)" alt="">
        <div class="rewards">
          <div v-for="(item, i) in taskList" class="chance_item">
            <div class="chance">
              <p class="name">
                <span v-if="i == 0">{{ i18n('facebook') }}</span>
                <span v-else-if="i == 1">{{ i18n('youtube') }}</span>
                <span v-else-if="i == 2">{{ i18n('discord') }}</span>
                <span v-else-if="i == 3">{{ i18n('sharefriend') }}</span>
              </p>
              <p class="count">({{ item.completed_count }}/{{ item.required_count }})</p>
              <a :class="['btn', { 'disable': item.completed_count == item.required_count }]"
                href="https://www.facebook.com/CrossGateAdventureTW/" target="_blank" v-if="i == 0"
                @click="completeTask(item.completed_count, item.required_count, item.id)">{{ i18n('follow')
                }}</a>
              <a :class="['btn', { 'disable': item.completed_count == item.required_count }]"
                href="https://www.facebook.com/CrossGateAdventureTW/" target="_blank" v-else-if="i == 1"
                @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                  i18n('follow') }}</a>
              <a :class="['btn', { 'disable': item.completed_count == item.required_count }]"
                href="https://discord.gg/VxzTeYJYzm" target="_blank" v-else-if="i == 2"
                @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                  i18n('follow') }}</a>
              <a :class="['btn', { 'disable': item.completed_count == item.required_count }]"
                href="https://forum.gamer.com.tw/B.php?bsn=84025" target="_blank" v-else-if="i == 3"
                @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                  i18n('share') }}</a>
            </div>
            <a :class="['btn wap_btn', { 'disable': item.completed_count == item.required_count }]"
              href="https://www.facebook.com/CrossGateAdventureTW/" target="_blank" v-if="i == 0"
              @click="completeTask(item.completed_count, item.required_count, item.id)">{{ i18n('follow')
              }}</a>
            <a :class="['btn wap_btn', { 'disable': item.completed_count == item.required_count }]"
              href="https://www.facebook.com/CrossGateAdventureTW/" target="_blank" v-else-if="i == 1"
              @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                i18n('follow') }}</a>
            <a :class="['btn wap_btn', { 'disable': item.completed_count == item.required_count }]"
              href="https://discord.gg/VxzTeYJYzm" target="_blank" v-else-if="i == 2"
              @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                i18n('follow') }}</a>
            <a :class="['btn wap_btn', { 'disable': item.completed_count == item.required_count }]"
              href="https://forum.gamer.com.tw/B.php?bsn=84025" target="_blank" v-else-if="i == 3"
              @click="completeTask(item.completed_count, item.required_count, item.id)">{{
                i18n('share') }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 中奖弹框 道具  -->
    <div class="pop_bg win_pop" v-if="showWin">
      <div class="win_area">
        <div class="close" @click="showWin = false"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/1-10/1_10_tit.png`)" alt="">
        <p :class="[language]"><i>{{win_name}}</i>{{ i18n('congratulations') }}</p>
        <button @click="showWin = false">{{ i18n('confirm') }}</button>
      </div>
    </div>
    <!-- 中奖弹框 实物 -->
    <div class="pop_bg yq_pop sw_pop" v-if="showSw">
      <div class="yq_area">
        <div class="close" @click="showSw = false;errmsg1='';errmsg2='';errmsg3='';errmsg4=''"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/3-3/3_3_tit.png`)" alt="">
        <p class="win_name">{{win_name}}</p>
        <div class="rewards form">
          <div class="form_item">
            <label>{{ i18n('name') }}：</label>
            <input type="text" :placeholder="i18n('enterName')" v-model="name" @blur="checkName" @input="errmsg1 = ''">
            <div class="errmsg" v-if="errmsg1 != ''">{{ errmsg1 }}</div>
          </div>
          <div class="form_item">
            <label>{{ i18n('email') }}：</label>
            <input type="email" :placeholder="i18n('enterEmail')" v-model="email" @blur="checkEmail"
              @input="errmsg2 = ''">
            <div class="errmsg" v-if="errmsg2 != ''">{{ errmsg2 }}</div>
          </div>
          <div class="form_item">
            <label>{{ i18n('phone') }}：</label>
            <input type="tel" :placeholder="i18n('enterPhone')" v-model="phone" @blur="checkPhone"
              @input="errmsg3 = ''">
            <div class="errmsg" v-if="errmsg3 != ''">{{ errmsg3 }}</div>
          </div>
          <div class="form_item">
            <label>{{ i18n('address') }}：</label>
            <input type="text" :placeholder="i18n('enterAddress')" v-model="address" @blur="checkAddress"
              @input="errmsg4 = ''">
            <div class="errmsg" v-if="errmsg4 != ''">{{ errmsg4 }}</div>
          </div>
          <p class="agree">
            <span :class="['check',{'checked': agree2 == true}]" @click="agree2 = !agree2;showErrmsg3 = false">
              <i class="errmsg" v-if="showErrmsg3">{{ i18n('agreefirst') }}</i>
            </span>
            <span @click="agree2 = !agree2;showErrmsg3 = false">{{ i18n('agree2_1') }}</span><a
              href="https://chuang-games.com/qjsj-useragreement.html" target="_blank">{{ i18n('agree2_2') }}</a>{{
            i18n('agree2_3') }}<a href="https://chuang-games.com/qjsj-privacypolicy.html" target="_blank">{{
              i18n('agree2_4') }}</a>{{ i18n('agree2_5') }}

          </p>
        </div>
        <button class="submit_btn" :disabled="submitdisabled" @click="submitAddress">{{ i18n('submit') }}</button>
      </div>
    </div>

    <!-- 新闻详情 -->
    <div class="pop_bg rule_pop" v-if="showNews">
      <div class="rule_area news_detail_area">
        <div class="close" @click="showNews = false"></div>
        <div class="cont">
          <p class="tit">{{ news_tit }}</p>
          <div class="news_cont" v-html="news_cont"></div>
        </div>
      </div>
    </div>

    <!-- 充值返利 登录弹框 -->
    <div class="pop_bg yq_pop fl_pop" v-if="showFl1">
      <div class="yq_area fl_area">
        <div class="close" @click="showFl1 = false"></div>
        <div class="rule_icon" @click="showFl4 = true"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/0/0-1/tit.png`)" alt="">
        <div class="login_form">
          <div class="form_item">
            <span class="label">{{ i18n('account') }}：</span>
            <input type="text" autocomplete="off" v-model="account" placeholder="请输入您的账号">
          </div>
          <div class="form_item">
            <span class="label">{{ i18n('password') }}：</span>
            <input type="password" autocomplete="off" v-model="password" placeholder="请输入您的密码">
          </div>
        </div>
        <button class="login_btn" :loading="loginLoading" @click="loginFl">立即登录</button>
        <div class="login_types">
          <a href="javascript:;"
            :style="{'backgroundImage': `url(${require(`../assets/zh/0/0-1/chuang.png`)})`}"
            title="chuang">Chuang Games</a>
          <a href="javascript:;"
            :style="{'backgroundImage': `url(${require(`../assets/zh/0/0-1/google.png`)})`}"
            title="google" @click="loginGoogle(1)">Google</a>
          <a href="javascript:;"
            :style="{'backgroundImage': `url(${require(`../assets/zh/0/0-1/facebook.png`)})`}"
            title="facebook" @click="loginFacebook(1)">Facebook</a>
        </div>
      </div>
    </div>
    <!-- 账号/密码错误 -->
    <div class="fl_error_pop" v-if="showFlerror1">
      <div class="error_tips">
        <div class="error_icon"></div>
        {{ i18n('error_account_or_password') }}
      </div>
      <button class="btn" @click="showFlerror1 = false">{{ i18n('confirm') }}</button>
    </div>
    <!-- 未查询到充值信息 -->
    <div class="fl_error_pop fl_error_pop2" v-if="showFlerror2">
      <div class="error_tips">
        <div class="error_icon error_icon2"></div>
        {{ i18n('unfind') }}
      </div>
      <div class="btns">
        <div class="btn btn1" @click="showFlerror2 = false">{{ i18n('close') }}</div>
        <a href="" class="btn btn2" target="_blank">{{ i18n('contactSupport') }}</a>
      </div>
    </div>
    <!-- 充值返利弹框 查询选择角色 -->
    <div class="pop_bg yq_pop fl_pop" v-if="showFl2">
      <div class="yq_area fl_area fl_area2">
        <div class="close" @click="showFl2 = false"></div>
        <div class="rule_icon" @click="showFl4 = true"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/0/0-1/tit.png`)" alt="">
        <p class="agree" @click="agree3 = !agree3">
          <span :class="['check',{'checked': agree3 == true}]" @click="agree3 = !agree3"></span>
          <span class="words">{{ i18n('agree3') }}</span>
        </p>
        <div class="select">
          <div class="label label2">請選擇遊戲包：</div>
          <div class="v-select">
           <el-select 
              v-model="app_id" 
              placeholder="請選擇遊戲包"
              @change="handleAppChange">
              <el-option
                v-for="item in optionApp"
                :key="item.value"
                :label="item.label"
                :value="item.app_id"
              ></el-option>
            </el-select>
          </div>
          <div class="label label2">{{ i18n('selectServer') }}：</div>
          <div class="v-select">
           <el-select 
              v-model="server_id" 
              :placeholder="i18n('selectServer')"
              @change="handleServerChange1">
              <el-option
                v-for="item in optionServer"
                :key="item.value"
                :label="item.server_name"
                :value="item.server_id"
              ></el-option>
            </el-select>
          </div>
          
          <div class="label label2">{{ i18n('confirmCharacter') }}：</div>
          <div class="v-select">
            <el-select 
              v-model="role_id" 
              :placeholder="i18n('confirmCharacter')"
              @change="handleServerChange2">
              <el-option
                v-for="item in optionCharacter"
                :key="item.value"
                :label="item.role_name"
                :value="item.role_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="btns">
          <div class="btn btn1" @click="showFl2 = false">{{ i18n('cancel') }}</div>
          <div class="btn btn2" @click="confirmRole">{{ i18n('confirm') }}</div>
        </div>
      </div>
    </div>
    <!-- 充值返利弹框 查询结果 -->
    <div class="pop_bg yq_pop fl_pop" v-if="showFl3">
      <div class="yq_area fl_area fl_area2 fl_area3">
        <div class="close" @click="showFl3 = false"></div>
        <div class="rule_icon" @click="showFl4 = true"></div>
        <img :class="['title',language]" :src="require(`../assets/${language}/0/0-1/tit.png`)" alt="">
        <div class="info">
          <p class="info_p">{{ i18n('currentRole') }}{{ server_name }}-{{ role_name }}</p>
          <p class="info_p">{{ i18n('totalRecharge') }}{{ total_recharge }}美元</p>
          <p class="info_p">{{ i18n('rebate') }}{{ rebate }}魔之星</p>
          <p class="rebateRule">{{ i18n('rebateRule') }}</p>
          <div class="table">
            <img :src="require(`../assets/${language}/0/0-5/table.png`)" alt="">
          </div>
        </div>
        <div class="btns"style="bottom: 0.9rem">
          <div class="btn btn1" @click="showFl3 = false">{{ i18n('cancel') }}</div>
          <div class="btn btn2" @click="showFl3_1 = true">{{ i18n('confirm') }}</div>
        </div>
      </div>
    </div>
    <!-- 领取 -->
    <div class="fl_error_pop fl_error_pop2" v-if="showFl3_1">
      <div class="error_tips">
        {{ i18n('isThisRole') }}
      </div>
      <div class="btns">
        <div class="btn btn1" @click="showFl3_1 = false">{{ i18n('cancel') }}</div>
        <div class="btn btn2" @click="confirmReceive">{{ i18n('confirm') }}</div>
      </div>
    </div>
    <!-- 领取成功 -->
    <div class="fl_error_pop fl_error_pop2" v-if="showFl3_2">
      <div class="error_tips">
        {{ i18n('receiveSuccess') }}
      </div>
      <div class="btns">
        <div class="btn btn1" @click="showFl3_2 = false">{{ i18n('cancel') }}</div>
        <div class="btn btn2" @click="showFl3_2 = false">{{ i18n('confirm') }}</div>
      </div>
    </div>
    <!-- 充值返利 活动规则弹框 -->
    <div class="pop_bg yq_pop fl_pop fl_pop2" v-if="showFl4">
      <div class="yq_area fl_area fl_area4">
        <div class="close" @click="showFl4 = false"></div>
        <img class="title" :src="require(`../assets/${language}/0/0-8/tit.png`)" alt="">
        <div class="rule_area">
          <div v-html="i18n('rebate_rule1')"></div>
          <div class="table">
            <img :src="require(`../assets/${language}/0/0-5/table.png`)" alt="">
          </div>
          <div v-html="i18n('rebate_rule2')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setToken,removeToken,setRoleInfo,getUserInfo, getRoleInfo,clearAuth } from '@/utils/auth'
import i18n from './i18n';
import section1 from './components/section1.vue';
import section2 from './components/section2.vue';
import section3 from './components/section3.vue';
import section4 from './components/section4.vue';
import section5 from './components/section5.vue';
import section6 from './components/section6.vue';
import section7 from './components/section7.vue';
import booking from './components/booking.vue';
import { swiper,swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { generateTrackingConfig } from '@/utils/tracking'
export default {
  metaInfo() {
    return generateTrackingConfig('GTM-KDPJBGT4', '823679893516430','D34H5HRC77UDLC199LG0')
  },
  components: {
    swiper,
    swiperSlide,
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
    section7,
    booking
  },
  computed: {
    ...mapGetters(['language', 'isLogin']),
  },
  data() {
    return {
      // 添加这两个属性来保存待执行的回调
      pendingCallback: null,
      pendingArgs: null,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        allowTouchMove: window.innerWidth <= 750, // 根据初始窗口宽度设置
        mousewheel: true,
        resistance: false,
        resistanceRatio: 0,
        preventClicks: false,
        preventClicksPropagation: false,
        on: {
          slideChange: () => {
            const activeIndex = this.active = this.$refs.swiper.swiper.activeIndex;
            // 查找匹配的 section 配置
            const sectionConfig = this.sectionConfigs.find(config => 
              config.index === activeIndex && !config.visited
            );
            if (sectionConfig) {
              sectionConfig.visited = true;
              this.$refs[sectionConfig.ref].onFirstVisit();
            }
          }
        }
      },
      sectionConfigs: [
        // { index: 1, ref: 'section2', visited: false },
        { index: 1, ref: 'section3', visited: false },
        { index: 2, ref: 'section4', visited: false },
        { index: 3, ref: 'section5', visited: false },
        { index: 4, ref: 'section6', visited: false },
        { index: 5, ref: 'section7', visited: false },
      ],
      active: 0,
      showlan: false,//语言
      showvideo: false,//视频
      isPlaying: false,//视频是否播放
      team_num: 0,//团队人数
      showyq: false,//邀请好友弹框
      showrule: false,//邀请规则弹框
      showrule2: false,//抽奖规则弹框
      showlogin: false,//登录弹框,
      showJoin: false,//加入团队弹框
      showInvite: false,//邀请好友弹框
      showJoinCode: false,//加入团队弹框 组队邀请码
      team_code: '',//组队邀请码
      showyy: false,//预约弹框
      showyySuccess: false,//预约成功弹框
      lottery_chances: 0,//抽奖次数
      inviteEmail: '',//邀请邮箱
      invitation_code: '',//邀请码
      reservation_info_invitation_code: '',
      cdkRewards: [],//邀请奖励列表
      showjljl1: false,//邀请好友奖励弹框
      taskList: [
        {},
        {},
        {}, 
        {},
      ],//任务列表
      showTask: false,//任务弹框
      win_name: '',//中奖的奖品名称
      showWin: false,//恭喜中奖弹框是否展示
      showSw: false,//实物奖励弹框是否展示
      submitdisabled: false,//提交按钮是否禁用
      name: '',//姓名
      email: '',//邮箱
      phone: '',//手机号
      address: '',//地址
      errmsg1: '',//姓名错误提示
      errmsg2: '',//邮箱错误提示
      errmsg3: '',//手机号错误提示
      errmsg4: '',//地址错误提示
      log_id: '',//实物中奖id
      agree2: true,//同意协议
      showErrmsg3: false,//同意协议错误提示

      menu: false,//移动端右上角menu开关
      youtubePlayer: null, // YouTube 播放器实例
      news_tit: '',//新闻详情标题
      news_cont: '',//新闻详情内容
      showNews: false,//新闻详情弹框是否展示
      showFl1: false,//充值返利登录弹框是否展示
      loginLoading: false,//账密登录loading
      // account: 'bdpdpw6dm',//充值返利账号
      // password: 'sjhy825995',//充值返利密码
      account: '',//充值返利账号
      password: '',//充值返利密码
      showFlerror1: false, //账号/密码错误
      showFlerror2: false, //未查询到充值信息
      agree3: true, // 充值返利 选择角色agree
      showFl2: false, //充值返利 选择角色弹框是否展示
      optionServer: [],
      server_id: null,
      server_name: '',
      optionCharacter: [],
      role_id: null,
      role_name: '',
      total_recharge: 0, // 总充值金额
      rebate: 0, // 返利金额
      showFl3: false, // 充值返利 查询结果弹框是否展示
      showFl3_1: false, //领取弹框
      showFl3_2: false, //领取成功弹框
      showFl4: false, //充值返利 活动规则弹框
      app_id: '',//游戏包
      optionApp: [
        {
          label: 'iOS',
          app_id: 'mlbbgat_1000217',
        },
        {
          label: '谷歌',
          app_id: 'mlbbgat_1000229',
        },
      ]
    }
  },
  mounted() {
    //this.changeSwiper(2)
    this.changeLanguage('tw')
    if(this.isLogin) {
      this.getUserInfo()
    }
    // 添加窗口大小变化监听
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      const windowWidth = window.innerWidth
      const shouldAllowTouch = windowWidth <= 750

      // 更新 swiperOption 中的 allowTouchMove
      this.swiperOption.allowTouchMove = shouldAllowTouch

      // 如果 swiper 已经初始化，更新其配置
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        if (shouldAllowTouch) {
          this.$refs.swiper.swiper.allowTouchMove = true
        } else {
          this.$refs.swiper.swiper.allowTouchMove = false
        }
        this.$refs.swiper.swiper.update()
      }
    },
    //获取任务列表
    getTaskList() {
      this.checkLoginAndExecute(() => {
        this.$http.get('MlbbTask/getTaskList').then(res => {
          if(res.code == 0) {
            this.showTask = true
            this.taskList = res.data
          }else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    //完成任务 获得抽奖机会
    completeTask(completed_count,required_count,id) {
      if(completed_count < required_count) {
        this.$http.post('MlbbTask/completeTask',{
          task_id: id
        }).then(res => {
          if(res.code == 0) {
            this.lottery_chances = res.data.lottery_chances
            this.getTaskList()
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    i18n,
    // 通用登录检验方法
    checkLoginAndExecute(callback, ...args) {      
      // 检查是否已登录
      if (this.isLogin) {
        // 已登录，直接执行回调函数
        if (typeof callback === 'function') {
          callback.apply(this, args);
        }
      } else {
        // 未登录，保存回调函数和参数，然后显示登录框
        this.pendingCallback = callback;
        this.pendingArgs = args;
        this.showlogin = true;
      }
    },
    //预约成功
    openyySuccess() {
      this.showyy = false
      this.showyySuccess = true
      // this.$refs.section2.getReservationCount()
    },
    //登录成功后需要刷新的数据
    async getUserInfo() {
      await this.$http.get('MlbbUser/getLotteryChances').then(res => {
        if(res.code == 0) {
          this.lottery_chances = res.data.lottery_chances
        }
      })
      await this.$http.post('MlbbUser/getReservationInfo').then(res => {
        if(res.code == 0) {
          this.inviteEmail = res.data.reservation_info.email
          this.team_num = res.data.group_info.member_count || 0
          this.invitation_code = res.data.group_info.invitation_code || ''
          this.reservation_info_invitation_code = res.data.reservation_info.invitation_code || ''
        }
      })
    },
    // 登录成功后的处理
    onLoginSuccess() {
      this.showlogin = false;
      this.getUserInfo()
      // 如果有待执行的回调函数，则执行它
      if (this.pendingCallback && typeof this.pendingCallback === 'function') {
        this.pendingCallback.apply(this, this.pendingArgs || []);
        // 清除待执行的回调
        this.pendingCallback = null;
        this.pendingArgs = null;
      }
    },
    changeSwiper(index) {
      this.$refs.swiper.swiper.slideTo(index);
    },
    changeLanguage(lang) {
      this.$store.commit('changeLanguage', lang)
    },
    //复制邀请信息的链接
    inviteFriends() {      
      this.$message.error('活動已結束')
      return
      if(this.invitation_code != '') {
        this.showInvite = true
        return
      }
      if(this.reservation_info_invitation_code != '') {
        this.invitation_code = this.reservation_info_invitation_code
        this.showInvite = true
        return
      }
      this.$http.post('MlbbInvitation/createGroup').then(res => {
        if(res.code == 0) {
          this.$message.success(res.msg)
          this.showInvite = true
          this.invitation_code = res.data.invitation_code
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    //立即预约
    ljyy() {
      this.showyy = true
      fbq('track', 'AddToWishlist');
      ttq.track('AddToWishlist');
      dataLayer.push({'event': 'button1-click'});
      // this.checkLoginAndExecute(() => {
        
      // })
    },
    //登录
    loginApple() {
      let vue_this = this;
      // 检查 Apple Sign-In 是否可用
      if (typeof AppleID === 'undefined') {
        vue_this.$message.error('Apple Sign-In is not available');
        return;
      }
      AppleID.auth.signIn()
      .then((result) => {        
        this.$http.post('MlbbUser/appStoreLogin',{
          code: result.authorization.code,
          id_token: result.authorization.id_token
        }).then(res => {
          if(res.code == 0) {
            vue_this.$message.success(res.msg)
            setToken(res.data.access_token)
            vue_this.$store.commit('setLoginStatus', true); // 更新登录状态
            setTimeout(() => {
              vue_this.onLoginSuccess();
            }, 500)
          }else {
            vue_this.$message.error(res.msg)
          }
        })
      })
      .catch((error) => {
        console.error('Apple Sign-In 错误:', error);
        // 根据错误类型显示不同消息
        switch (error.error) {
          case 'popup_closed_by_user':
            // 用户关闭弹窗，不显示错误消息
            break;
          case 'invalid_client':
            vue_this.$message.error('Apple Login configuration error');
            break;
          default:
            vue_this.$message.error('Apple Login failed, please try again');
        }
      });
    },
    loginGoogle(e) {
      let vue_this = this
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider)
      .then((result) => {
        const userData = {
          id_token: result.credential.idToken,
          googleId: result.user.uid,
          name: result.user.displayName,
          email: result.user.email,
          language: vue_this.languagene
        }
        try{     
          if(userData.id_token) {
            this.$http.post('MlbbUser/googleLogin',{id_token: userData.id_token}).then(res => {
              if(res.code == 0) {
                vue_this.$message.success(res.msg)
                setToken(res.data.access_token)
                vue_this.$store.commit('setLoginStatus', true); // 更新登录状态
                setTimeout(() => {
                  vue_this.onLoginSuccess();
                }, 500)
                if(e == 1) {
                  this.showFl1 = false  //成功
                  this.showFl2 = true
                }
              }else {
                vue_this.$message.error(res.msg)
              }
            })
          }
        }catch (error) {
          console.log(error);
        }
      })
    },
    loginFacebook(e) {
      let vue_this = this
      FB.login(function (response) {
        if (response.status === 'connected') {
          try {
            vue_this.$http.post('MlbbUser/facebookLogin', {access_token: response.authResponse.accessToken}).then(res => {
                if (res.code == 0) {
                  vue_this.$message.success(res.msg)
                  setToken(res.data.access_token)
                  vue_this.$store.commit('setLoginStatus', true); // 更新登录状态
                  setTimeout(() => {
                    vue_this.onLoginSuccess();
                  }, 500)
                  if(e == 1) {
                    this.showFl1 = false  //成功
                    this.showFl2 = true
                  }
                } else {
                  vue_this.$message.error(res.msg)
                }
              })
            } catch (error) {
              console.log(error);
            }
        } 
      }, {scope: 'public_profile,email',display: "popup"})
    },
    // 初始化 YouTube 播放器
    initYouTubePlayer() {
      if (window.YT && window.YT.Player) {
        const iframe = this.$refs.video;
        if (iframe) {
          // 为 iframe 添加唯一 ID
          const playerId = 'youtube-player-' + Date.now();
          iframe.id = playerId;
      
          this.youtubePlayer = new YT.Player(playerId, {
            events: {
              'onReady': this.onPlayerReady,
              'onStateChange': this.onPlayerStateChange
            }
          });
        }
      } else {
        console.warn('YouTube API not loaded yet');
      }
    },
    // 添加播放器就绪事件处理
    onPlayerReady(event) {
      console.log('YouTube player is ready');
      // 播放器准备就绪后可以进行操作
    },
    onVideoLoad() {
      // 确保 YouTube API 已加载
      if (window.YT && window.YT.Player) {
        this.initYouTubePlayer();
      } else {
        // 如果 API 还未加载，等待一段时间后重试
        setTimeout(() => {
          this.onVideoLoad();
        }, 100);
      }
    },
    // 播放器状态变化处理
    onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
        this.isPlaying = true;
      } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
        this.isPlaying = false;
      }
    },
  
    // 修改 openvideo 方法
    openvideo() {
      this.showvideo = true;
        // 等待 DOM 更新和 YouTube API 加载
      this.$nextTick(() => {
        setTimeout(() => {
          if (window.YT && window.YT.loaded) {
            this.initYouTubePlayer();
          } else {
            // 等待 YouTube API 加载完成
            window.onYouTubeIframeAPIReady = () => {
              this.initYouTubePlayer();
            };
          }
        }, 300);
      });
    },
  
    // 修改 closevideo 方法
    closevideo() {
      this.showvideo = false;
      this.youtubePlayer = null;
    },
  
    // 修改 togglePlay 方法
    togglePlay() {
      if (this.youtubePlayer && typeof this.youtubePlayer.playVideo === 'function') {
        if (this.isPlaying) {
          this.youtubePlayer.pauseVideo();
        } else {
          this.youtubePlayer.playVideo();
        }
      } else {
        console.warn('YouTube player not initialized or playVideo method not available');
        // 尝试重新初始化
        this.initYouTubePlayer();
      }
    },
    //邀请
    showYq() {
      this.checkLoginAndExecute(() => {
        this.showyq = true
      })
    },
    //加入团队
    joinGroup() {
      if(this.team_code.trim() == '') {
        this.$message.error(this.i18n('enterTeamCode'))
        return
      }
      this.$http.post('MlbbInvitation/joinGroup',{
        invitation_code: this.team_code
      }).then(res => {
        if(res.code == 0) {
          this.showyq = false
          this.showJoinCode = false
          this.$message.success(res.msg)
          if(this.inviteEmail == '' || this.inviteEmail == null) {
            this.showyq = true
          }
          this.getUserInfo()
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    //复制邀请链接
    copyInviteLink() {
      var link = this.i18n('copytxt') + window.location.origin + '?invitation_code=' + this.invitation_code
      this.$copyText(link).then(() => {
        this.$message.success(this.i18n('copysuccess'))
      })
    },
    //获取邀请奖励列表
    getInvitationCdkRewards() {
      this.showjljl1 = true
      this.$http.post('MlbbUser/getInvitationCdkRewards').then(res => {
        if(res.code == 0) {
          this.cdkRewards = res.data
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    //提交实物奖励地址
    submitAddress() {
      this.submitdisabled = true
      if(!this.agree2) {
        this.$message.error(this.i18n('agreefirst'))
        setTimeout(() => {
          this.submitdisabled = false
        }, 3000)
        return
      }
      if(!this.checkName() || !this.checkEmail() || !this.checkPhone() || !this.checkAddress() || !this.agree2) {
        setTimeout(() => {
          this.submitdisabled = false
        }, 3000)
        return
      }
      this.$http.post('MlbbLottery/saveShippingInfo',{
        log_id: this.log_id,
        name: this.name,
        email: this.email,
        phone: this.phone,
        address: this.address,
      }).then(res => {
        if(res.code == 0) {
          this.$message.success(res.msg)
          this.showSw = false
        }else {
          this.$message.error(res.msg)
        }
      })
      setTimeout(() => {
        this.submitdisabled = false
      }, 2000)
    },
    //检验姓名
    checkName() {
      if(this.name == '') {
        this.$message.error(this.i18n('enterName'))
        return false
      }else {
        this.errmsg1 = ''
        return true
      }
    },
    //检验邮箱格式
    checkEmail() {
      if(this.email == '') {
          this.$message.error(this.i18n('enterEmail'))
          return false
      }else {
        const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(this.email)) {
          this.$message.error(this.i18n('validemail'))
          return false
        }else {
          this.errmsg2 = ''
          return true
        }
      }
    },
    //检验手机号
    checkPhone() {
      if(this.phone == '') {
        this.$message.error(this.i18n('enterPhone'))
        return false
      }else {
        this.errmsg3 = ''
        return true
      }
    },
    //检验地址
    checkAddress() {
      if(this.address == '') {
        this.$message.error(this.i18n('enterAddress'))
        return false
      }else {
        this.errmsg4 = ''
        return true
      }
    },
    //退出登录
    logout() {
      clearAuth()
    },
    getNewsDetail(val) {
      this.news_tit = val.title
      this.news_cont = val.content
      this.showNews = true
    },

    //打开充值 登录框
    openFlLogin() {
      if(this.isLogin) {
        if(getRoleInfo() && getRoleInfo().role_id) {
          this.getRechargeRebateStatus()
          this.app_id = getRoleInfo().app_id
          this.server_id = getRoleInfo().server_id
          this.server_name = getRoleInfo().server_name
          this.role_id = getRoleInfo().role_id
          this.role_name = getRoleInfo().role_name
        }else {
          this.showFl2 = true
          this.app_id = ''
          this.optionServer = []
          this.server_id = null
          this.server_name = ''
          this.optionCharacter = []
          this.role_id = null
          this.role_name = ''
        }
      }else {
        this.account = ''
        this.password = ''
        this.showFl1 = true
      }
    },
    loginFl() {
      //ajax 登录
      //this.showFlerror1 = true  //账号/密码错误
      //this.showFlerror2 = true  //未查询到信息 
      if (this.loginLoading) return
      this.loginLoading = true
      var params = {
        username: this.account,
        password: this.password,
      }
      //this.$emit('update:showlogin', false)
      this.$http.post('/MlbbUser/login', params).then(res => {
        if (res.code == 0) {
          this.$message.success('Login successful')
          setToken(res.data.access_token)
          this.$store.commit('setLoginStatus', true); // 更新登录状态
          this.showFl1 = false  //成功
          this.showFl2 = true
          this.optionServer = []
          this.server_id = null
          this.server_name = ''
          this.optionCharacter = []
          this.role_id = null
          this.role_name = ''
        } else {
          this.$message.error(res.msg)
        }
      })
      setTimeout(() => {
        this.loginLoading = false
      }, 2000)
    },
    getServerList(app_id) {
      this.$http.post('/MlbbUser/getServerList',{
        app_id
      }).then(rs => {
        if(rs.code == 0) {
          this.optionServer = this.toServerOptions(rs.data.serverList)

        }
      })
    },
    toServerOptions(list) {
      if (!list || typeof list !== 'object') return [];
      return Object.keys(list)
        .map(id => ({ server_id: String(id), server_name: String(list[id] || '') }))
        .filter(item => item.server_id && item.server_name)
        .sort((a, b) => Number(a.server_id) - Number(b.server_id)); // 可选：按数值升序
    },
    handleAppChange(e) {
      this.app_id = e
      this.optionServer = []
      this.server_id = null
      this.server_name = ''
      this.optionCharacter = []
      this.role_id = null
      this.role_name = ''
      this.getServerList(e)
    },
    handleServerChange1(value) {
      this.optionCharacter = []
      this.role_id = null
      this.role_name = ''
      this.server_name = this.optionServer.find(item => item.server_id == value)?.server_name || ''
      //ajax 根据选择的区服获取角色列表
      this.getRoleList()
    },
    getRoleList() {
      this.$http.post('MlbbUser/getRoleList',{
        server_id: this.server_id,
        app_id: this.app_id
      }).then(rs => {
        if(rs.code == 0) {
          this.optionCharacter = rs.data.list
        }
      })
    },
    handleServerChange2(value) {
      this.role_name = this.optionCharacter.find(item => item.role_id == value)?.role_name || ''
    },
    //确定领取角色
    confirmRole() {
      if(!this.app_id) {
        this.$message.error('請選擇遊戲包')
        return
      }
      if(!this.server_id) {
        this.$message.error(this.i18n('selectServer'))
        return
      }
      if(!this.role_id) {
        this.$message.error(this.i18n('confirmCharacter'))
        return
      }
      if(!this.agree3) {
        this.$message.error(this.i18n('agreefirst'))
        return
      }
      setRoleInfo({app_id: this.app_id,server_id: this.server_id,server_name: this.server_name, role_id: this.role_id, role_name: this.role_name})
      //ajax  选定角色  获取角色的充值信息
      this.getRechargeRebateStatus()
    },
    getRechargeRebateStatus() {
      this.$http.post('MlbbUser/getRechargeRebateStatus',{
        server_id: this.server_id,
        role_id: this.role_id,
        app_id: this.app_id
      }).then(rs => {
        if(rs.code == 0) {
          this.total_recharge = rs.data.recharge_amount
          this.rebate = rs.data.rebate_item_count
          this.showFl2 = false
          this.showFl3 = true
        }else {
          this.$message.error(rs.msg)
        }
      })
    },
    //确认领取
    confirmReceive() {
      //ajax  领取绑定角色的充值奖励
      this.$http.post('/MlbbUser/claimRechargeRebate',{
        rolename: this.role_name,
        roleid: this.role_id,
        serverid: this.server_id,
        app_id: this.app_id
      }).then(rs => {
        if(rs.code == 0) {
          this.showFl3_1 = false;
          this.showFl3_2 = true
        }else {
          this.$message.error(rs.msg)
        }
      })
    }
  },
  watch: {
    // 监听路由参数变化
    '$route.query.invitation_code': {
      handler(newInviteCode) {
        // 只在有新的邀请码时显示弹框
        if (newInviteCode) {
          if (this.isLogin) {
            this.showJoinCode = true
            this.team_code = newInviteCode
          } else {
            this.checkLoginAndExecute(() => {
              this.showJoinCode = true
              this.team_code = newInviteCode
            })
          }
        }
      },
      immediate: true
    }
  },
};
</script>
<style lang="less" scoped>
  @keyframes circle {
    0%{
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .navs {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1920px;
    height: 1.4rem;
    display: flex;
    justify-content: space-between;
    padding: 0 .7rem 0 .45rem;
    .nav_left {
      display: flex;
      align-items: center;
      .logo {
        margin-top: .12rem;
        margin-right: .75rem;
        width: 2rem;
        height: 1.45rem;
        background: url('../assets/zh/1/logo.png') 0 0 / 100% 100% no-repeat;
      }

      ul {
        height: .56rem;
        display: flex;
        align-items: center;
        li {
          height: 100%;
          margin-right: .9rem;
          display: flex;
          justify-content: center;
          cursor: pointer;
          img {
            width: auto;
            height: 100%;
            user-select: none;
          }
        }
      }
    }
    .nav_right {
      height: 1.4rem;
      display: flex;
      align-items: center;
      .logout {
        color: #B04B30;
        margin-right: .3rem;
        font-size: .28rem;
        font-weight: 700;
        border-bottom: 1px solid #B04B30;
        cursor: pointer;
        white-space: nowrap;
        -webkit-tap-highlight-color: transparent;
        &:hover {
          color: #fff;
          border-color: #fff;
        }
      }
      .ljyy {
        border: none;
        min-width: 2.75rem;
        padding: 0 0.2rem;
        height: .68rem;
        line-height: .66rem;
        background: url(../assets/zh/1-1/yy_bg.png) 0 0 / 100% 100% no-repeat;
        font-size: .3rem;
        font-weight: bold;
        color: #B04B30;
        margin-right: .3rem;
        user-select: none;
        text-align: center;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &:active {
          transform: scale(0.98);
        }
        &.en,
        &.in,
        &.fi {
          font-size: .22rem;
        }
      }
      a {
        width: .4rem;
        height: .47rem;
        margin-right: .32rem;
        // background: url(../assets/zh/1/icon_box.png) 0 0 / 100% 100% no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          width: 100%;
          height: 100%;
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        &.youtube {
          i {
            background-image: url(../assets/zh/1/youtube.png);
          }
        }
        &.discord {
          i {
            background-image: url(../assets/zh/1/discord.png);
          }
        }
        &.fanpage {
          i {
            background-image: url(../assets/zh/1/facebook.png);
          }
        }
      }
      .language-select {
        margin-left: .1rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        -webkit-tap-highlight-color: transparent;
        width: 1.45rem;
        height: .46rem;
        background: url(../assets/zh/1/earth.png) 0 0 / 100% 100% no-repeat;
        span {
          width: 100%;
          text-align: center;
          padding-left: .1rem;
          color: #B04B30;
          font-size: .24rem;
          line-height: .44rem;
        }
        &.th,
        &.in,
        &.fi {
          height: .6rem;
          background: url(../assets/zh/1/earth2.png) 0 0 / 100% 100% no-repeat;
          span {
            font-size: .22rem;
            white-space: nowrap;
          }
        }
      }
      .menu {
        display: none;
      }
    }
    .language-options {
      position: absolute;
      top: 1.2rem;
      right: .6rem;
      width: 3.26rem;
      padding: .15rem 0 .15rem .25rem;
      background: url(../assets/zh/1/lan_bg.png) 0 0 / 100% 100% no-repeat;
      li {
        color: #fff;
        height: .45rem;
        line-height: .45rem;
        font-size: .32rem;
        cursor: pointer;
        text-align: center;
        &.active {
          color: #feffac;
          background: url(../assets/zh/1/choose.png) 2.4rem .1rem / .29rem .25rem no-repeat;
        }
      }
    }
  }
  .swiper-container {
    /* 使用dvh（动态视口高度）替代100vh */
    height: 100dvh;
    /* 兼容性回退 */
    height: 100vh;
    height: 100dvh;
  }
  .close {
    position: absolute;
    width: 1.21rem;
    height: 1.21rem;
    background: url(../assets/zh/1/close.png) 0 0 / 100% 100% no-repeat;
    cursor: pointer;
    transition: all ease .3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      transform: scale(1.1);
    }
  }
  .pop_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    z-index: 200;
  }
  .video_pop {
    .video_area {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      width: 13.35rem;
      height: 7.5rem;
      background-color: #000;
      .play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 1.04rem;
        height: 1.04rem;
        z-index: 10;
        background: url(../assets/zh/1-1/play.png) .45rem center / .29rem .53rem no-repeat;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(../assets/zh/1-1/play_bg.png) 0 0 / 100% 100% no-repeat;
            animation: circle 3s linear infinite;
        }
        &:active {
          transform: translate(-50%,-50%) scale(0.98);
        }
      }
      .close {
        top: -1rem;
        right: -1.3rem;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
  .yq_pop {
    .yq_area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 10.91rem;
      height: 6.19rem;
      background: url(../assets/zh/1-3/yq_area.png) 0 0 / 100% 100% no-repeat;
      &::before {
        content: '';
        position: absolute;
        top: -0.1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 7.1rem;
        height: 1.45rem;
        background: url(../assets/zh/1-3/tit_bg.png) 0 0 / 100% 100% no-repeat;
        z-index: -1;
      }
      .close {
        top: -0.16rem;
        right: -0.25rem;
      }
      .title {
        display: block;
        height: .41rem;
        width: auto;
        margin: .45rem auto .35rem;
      }
      .rewards {
        position: relative;
        width: 10.61rem;
        height: 4.24rem;
        margin: 0 auto;
        padding-top: .4rem;
        &.rewards2 {
          padding-top: 0;
          height: 4.7rem;
        }
        ul {
          margin: 0 auto .35rem;
          width: 7.8rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          li {
            width: 2.41rem;
            height: 2.18rem;
            background: url(../assets/zh/1-3/reward_bg.png) 0 0 / 100% 100% no-repeat;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            padding-bottom: .12rem;
            img {
              width: .98rem;
              height: .98rem;
            }
            span {
              margin-top: .2rem;
              font-size: .18rem;
              color: #d6d0c5;
            }
          }
        }
        .nums {
          width: 7.8rem;
          margin: 0 auto;
          display: flex;
          align-items: center;
          font-size: .18rem;
          color: #d6d0c5;
          .nums_area {
            margin-left: .1rem;
            padding-left: .2rem;
            width: 4.88rem;
            height: .54rem;
            line-height: .54rem;
            color: #ffe94c;
            background: url(../assets/zh/1-3/num_bg.png) 0 0 / 100% 100% no-repeat;
          }
        }
        .record_btn {
          position: absolute;
          right: .2rem;
          bottom: .12rem;
          color: #1b71b1;
          font-size: .15rem;
          cursor: pointer;
          &:hover {
            color: #fff;
          }
        }
      }
      .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          margin-top: .08rem;
          width: 2.92rem;
          height: .87rem;
          line-height: .75rem;
          text-align: center;
          border: none;
          outline: none;
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-color: transparent;
          font-size: .24rem;
          font-weight: 700;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
          user-select: none;
          &:active {
            transform: scale(0.98);
            opacity: 0.9;
          }
          &.btn1 {
            color: #3051B0;
            margin-right: .2rem;
            background-image: url(../assets/zh/1-3/btn1.png);
          }
          &.btn2 {
            background-position: 0 0.03rem;
            background-size: 100% .68rem;
            color: #B04B30;
            background-image: url(../assets/zh/1-3/btn2.png);
          }
        }
      }
      .rule {
        position: absolute;
        right: .26rem;
        bottom: .2rem;
        font-size: .16rem;
        display: flex;
        align-items: center;
        color: #d6d0c5;
        cursor: pointer;
        i {
          width: .3rem;
          height: .3rem;
          margin-right: .05rem;
          background: url(../assets/zh/1-3/rule.png) 0 0 / 100% 100% no-repeat;
        }
      }
      .jljl {
        width: 100%;
        height: calc(100% - 0.3rem);
        padding: .4rem 0.5rem;
        text-align: center;
        overflow-y: auto;
        p {
          font-size: .32rem;
          color: #723F31;
          margin-bottom: 0.1rem;
        }
        &::-webkit-scrollbar {
          width: .12rem;
        }
        &::-webkit-scrollbar-track {
          width: .05rem;
          border-top: none;
          border-bottom: none;
          background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
        }
        &::-webkit-scrollbar-thumb {
          width: .12rem;
          background-color: #D37966;
          border-radius: 0.2rem;
        }
      }
    }
  }
  // 邀请好友弹框
  .yq_pop.yq_pop2 {
    .yq_area {
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title {
        height: .95rem;
        margin: -0.2rem auto .25rem;
      }
    }
    .rewards {
      width: 8.9rem;
      height: 3.57rem;
      background: url(../assets/zh/1-3/reward_bg.png) 0 0 / 100% 100% no-repeat;
      ul {
        width: 6.8rem;
        margin: 0 auto .25rem;
        li {
          height: 2rem;
          width: unset;
          flex: 1;
          background: unset;
          justify-content: flex-start;
          padding-top: 1.4rem;
          word-break: break-all;
          span {
            font-size: .2rem;
            color: #fff;
            font-weight: 700;
          }
        }
      }
      .nums {
        justify-content: center;
        color: #fff;
        font-size: .2rem;
        font-weight: 700;
        .nums_area {
          margin-left: 0;
          width: 4.5rem;
          height: .6rem;
          line-height: .6rem;
          color: #5B62BA;
          padding-left: 0.4rem;
          font-weight: normal;
        }
      }
      .record_btn {
        color: #fff;
        font-weight: 700;
        font-size: .2rem;
        bottom: .2rem;
        right: .3rem;
        user-select: none;
      }
    }
    .rule {
      position: absolute;
      bottom: .9rem;
      right: 1.2rem;
      color: #723F31;
      font-size: .2rem;
      font-weight: 700;
      i {
        width: .19rem;
        height: .28rem;
        margin-right: .1rem;
      }
    }
  }
  .rule_pop {
    z-index: 300;
    .rule_area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 14.38rem;
      height: 7.75rem;
      background: url(../assets/zh/1-3/rule_bg.png) 0 0 / 100% 100% no-repeat;
      z-index: 301;
      padding: 1.25rem 1.2rem 1.5rem 1.7rem;
      color: #723F31;
      font-size: .22rem;
      word-break: break-all;
      .cont {
        padding-right: .1rem;
        line-height: 1.8;
        height: 5rem;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: .12rem;
        }
        &::-webkit-scrollbar-track {
          width: .05rem;
          border-top: none;
          border-bottom: none;
          background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
        }
        &::-webkit-scrollbar-thumb {
          width: .12rem;
          background-color: #D37966;
          border-radius: 0.2rem;
        }
        .title {
          text-align: center;
          font-weight: 700;
          color: #723F31;
          font-size: .32rem;
          margin-bottom: .1rem;
        }
        &.cont2 {
          ::v-deep p:nth-child(1) {
            text-align: center;
            font-weight: 700;
            color: #723F31;
            font-size: .32rem;
            margin-bottom: .1rem;
          }
        }
      }
      .close {
        right: -0.24rem;
        top: -0.18rem;
      }
      &.news_detail_area {
        // height: 70%;
        height: 9rem;
        .close {
          top: -.1rem;
          right: -.2rem;
        }
        .cont {
          height: 100%;
          .tit {
            font-size: .34rem;
            font-weight: 700;
            margin-bottom: 6px;
            text-align: center;
          }
          ::v-deep .news_cont {
            font-size: .24rem;
            word-break: break-all;
            p,span {
              font-size: .24rem !important;
            }
            img {
              max-width: 100%;
              height: auto !important;
            }
          }
        }
      }
    }
  }
  .login_pop {
    .login_area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 8.28rem;
      height: 6.53rem;
      background: url(../assets/zh/1-4/login_bg.png) 0 0 / 100% 100% no-repeat;
      padding-top: .3rem;
      padding-bottom: .3rem;
      .close {
        right: -0.24rem;
        top: -0.24rem;
      }
      .logo {
        margin: 0.1rem auto 0;
        width: 3.71rem;
        height: 2.94rem;
        background: url(../assets/zh/1/logo.png) 0 0 / 100% 100% no-repeat;
      }
      a {
        display: block;
        margin: -0.25rem auto .4rem;
        width: 4.9rem;
        height: .64rem;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(../assets/zh/1-4/kuang.png);
        img {
          display: block;
          width: 70%;
          height: auto;
          margin: 0 auto;
          transform: translateY(0.1rem);
        }
        &:active {
          transform: scale(0.98);
          opacity: 0.8;
        }
      }
    }
  }
  .join_pop {
    .join_area {
      width: 8.47rem;
      height: 6.72rem;
      background: url(../assets/zh/1-5/bg.png) 0 0 / 100% 100% no-repeat;
      position: relative;
      .close {
        top: -0.12rem;
        right: -0.12rem;
      }
      .title {
        display: block;
        height: 1.08rem;
        width: auto;
        margin: -0.1rem auto .7rem;
      }
      .join_btn {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: .65rem;
        display: table;
        width: unset;
        min-width: 2.75rem;
        padding: 0 0.5rem;
        height: .68rem;
        line-height: .68rem;
        font-size: .3rem;
        white-space: nowrap;
        text-align: center;
        color: #B04B30;
        font-weight: 700;
        background: url(../assets/zh/1-5/btn_bg.png) 0 0 / 100% 100% no-repeat;
        &:active {
          transform: translateX(-50%) scale(0.98);
          opacity: 0.8;
        }
      }
    }
  }
  .invite_pop {
    .invite_area {
      .title {
        width: 5.5rem;
        height: auto;
        margin-top: -.1rem;
        &.zh,
        &.th {
          margin-top: .15rem;
        }
      }
      .invite_btn {
        min-width: 4.16rem;
        height: .7rem;
        line-height: .68rem;
        background: url(../assets/zh/1-6/btn_bg.png) 0 0 / 100% 100% no-repeat;
      }
    }
  }
  .join_code_pop {
    .join_code_area {
      width: 8.47rem;
      height: 6.72rem;
      background: url(../assets/zh/1-7/bg.png) 0 0 / 100% 100% no-repeat;
      position: relative;
      .team_code {
        display: block;
        border: none;
        outline: none;
        margin: 0 auto .5rem;
        width: 6.14rem;
        height: .77rem;
        background: url(../assets/zh/1-7/border.png) 0 0 / 100% 100% no-repeat;
        text-align: center;
        font-size: .2rem;
        color: #723F31;
        &::placeholder {
          color: #DDB39A;
        }
      }
    }
  }
  .yy_pop {
    .yy_area {
      width: 12.06rem;
      height: 7.7rem;
      background: url(../assets/zh/1-8/yy_bg.png) 0 0 / 100% 100% no-repeat;
      &.en,
      &.in,
      &.fi {
        height: 8rem;
      }
      &::before {
        content: '';
        position: absolute;
        top: 0.5rem;
        left: 50%;
        transform: translateX(-50%);
        width: 7.1rem;
        height: 1.45rem;
        background: url(../assets/zh/1-8/tit_bg.png) 0 0 / 100% 100% no-repeat;
        z-index: -1;
      }
      .close {
        top: -0.01rem;
        right: -0.13rem;
      }
      .title {
        height: .94rem;
        margin: .4rem auto .95rem;
      }
      .rewards {
        padding: 0 .5rem;
        background: unset !important;
      }
    }
    ::v-deep .yy_area {
      .errmsg {
        &.err2 {
          left: .3rem;
        }
      }
    }
  }
  .yy_success_pop {
    z-index: 300;
    .yy_success_area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8.28rem;
      height: 6.53rem;
      padding-top: 1rem;
      background: url(../assets/zh/1-9/1_9_box.png) 0 0 / 100% 100% no-repeat;
      position: absolute;
      .close {
        top: -0.25rem;
        right: -0.24rem;
      }
      .p1 {
        width: 1.24rem;
        height: 1.25rem;
        background: url(../assets/zh/1-9/1_9_success-icon.png) 0 0 / 100% 100% no-repeat;
        margin: 0 auto .8rem;
      }
      .p2 {
        display: block;
        margin: 0 auto;
        width: 5.5rem;
        height: auto;
        &.in {
          margin-top: 1rem;
        }
      }
      .p3 {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 1rem;
        padding: 0 .5rem;
        min-width: 2.75rem;
        height: .68rem;
        line-height: .68rem;
        text-align: center;
        background: url(../assets/zh/1-9/1_9_btnbg.png) 0 0 / 100% 100% no-repeat;
        font-size: .3rem;
        font-weight: 700;
        color: #B04B30;
        cursor: pointer;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .chance_pop {
    .chance_area {
      width: 12.06rem;
      height: 6.72rem;
      background: url(../assets/zh/3-2/bg.png) 0 0 / 100% 100% no-repeat;
      &::before {
        top: .5rem;
      }
      .close {
        top: -.04rem;
        right: -.12rem;
      }
      .title {
        margin-top: .35rem;
        margin-bottom: .25rem;
        height: .96rem;
      }
      .rewards {
        height: 4.3rem;
        padding: .4rem 0;
        .chance_item {
          &:nth-child(1) {
            .chance {
              background-image: url(../assets/zh/3-2/facebook.png);
            }
          }
          &:nth-child(2) {
            .chance {
              background-image: url(../assets/zh/3-2/youtube.png);
            }
          }
          &:nth-child(3) {
            .chance {
              background-image: url(../assets/zh/3-2/discord.png);
            }
          }
          &:nth-child(4) {
            .chance {
              background-image: url(../assets/zh/3-2/share.png);
            }
          }
        }
        .chance {
          margin: 0 auto .1rem;
          padding: 0 .26rem;
          padding-right: 0;
          width: 9.18rem;
          height: .76rem;
          background-position: 0 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: .9rem;

          p {
            color: #723F31;
            font-weight: 700;
            font-size: .3rem;
            display: flex;
            align-items: center;
            img {
              width: .51rem;
              height: .51rem;
              margin-right: .1rem;
            }
          }
          .name {
            width: 3rem;
            white-space: nowrap;
          }
          .count {
            color: #723F31;
            font-weight: normal;
          }
          .btn {
            width: 2.75rem;
            height: .68rem;
            background: url(../assets/zh/3-2/3_2_btn.png) 0 0 / 100% 100% no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #B04B30;
            font-weight: 700;
            font-size: .25rem;
            &:active, &.disable {
              opacity: 0.8;
            }
            &.disable {
              cursor: not-allowed;
              pointer-events: none;
            }
          }
        }
        .wap_btn {
          display: none;
        }
      }
    }
  }
  .win_pop {
    .win_area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8.47rem;
      height: 6.72rem;
      background: url(../assets/zh/1-10/1_10_box.png) 0 0 / 100% 100% no-repeat;
      padding-top: 1rem;
      &::before {
        content: '';
        position: absolute;
        top: -0.6rem;
        left: 50%;
        transform: translateX(-50%);
        width: 6.92rem;
        height: 3.68rem;
        background: url(../assets/zh/1-10/tit_bg.png) 0 0 / 100% 100% no-repeat;
        z-index: -1;
      }
      .close {
        right: -0.15rem;
        top: -0.15rem;
      }
      .title {
        display: block;
        width: auto;
        height: .59rem;
        margin: 0 auto;
        max-width: 100%;
      }
      p {
        padding: 0 1.4rem;
        color: #723F31;
        font-size: .24rem;
        text-align: start;
        margin-top: 1rem;
        i {
          display: block;
          width: 100%;
          text-align: center;
          font-weight: 700;
          font-size: .3rem;
          margin-bottom: .1rem;
        }
        &.en {
          margin-top: 1rem;
        }
      }
      button {
        position: absolute;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        border: none;
        background-color: transparent;
        min-width: 2.75rem;
        padding: 0 .5rem;
        height: .68rem;
        font-size: .3rem;
        font-weight: 700;
        color: #B04B30;
        background: url(../assets/zh/1-10/1_10ty_Button.png) 0 0 /100% 100% no-repeat;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .sw_pop {
    .yq_area {
      width: 12.06rem;
      height: 6.72rem;
      background: url(../assets/zh/3-3/bg.png) 0 0 / 100% 100% no-repeat;
      &::before {
        width: 7.1rem;
        height: 1.45rem;
        top: .25rem;
      }
      .title {
        height: .96rem;
        margin-top: 0.2rem;
        margin-bottom: .2rem;
        max-width: 100%;
      }
      .win_name {
        text-align: center;
        color: #723F31;
        font-size: .3rem;
        font-weight: 700;
        margin-bottom: 0.2rem;
      }
      .form {
        height: auto !important;
        padding-bottom: 0.3rem;
        padding-top: 0;
        .form_item {
          width: 9.2rem;
          margin: 0 auto .05rem;
          display: flex;
          align-items: center;
          position: relative;
          label {
            flex: 1;
            text-align: end;
            font-size: .2rem;
            color: #723F31;
            font-weight: 700;
            white-space: nowrap;
            letter-spacing: 0.02rem;
          }
          input {
            width: 7.8rem;
            height: .52rem;
            border: none;
            outline: none;
            background: transparent url(../assets/zh/3-3/3_3_border.png) 0 0 / 100% 100% no-repeat;
            padding: 0 0.6rem;
            font-size: .22rem;
            color: #723F31;
            &::placeholder {
              color: #E4C4B1;
            }
          }
        }
      }
    }

    .errmsg {
      position: absolute;
      left: 1.8rem;
      height: .3rem;
      line-height: .3rem;
      bottom: -0.3rem;
      font-size: .2rem;
      color: red;   
      text-align: start;  
      white-space: nowrap;
    }
    .agree {
      font-size: .2rem;
      color: #723F31;
      margin-bottom: .3rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      line-height: 2;
      -webkit-tap-highlight-color: transparent;
      padding-left: 1rem;
      a {
        color: #B04B30;
        position: relative;
      }
      .check {
        position: relative;
        width: .26rem;
        height: .26rem;
        margin-right: .16rem;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(../assets/zh/1-8/notselected.png);
        &.checked {
            background-image: url(../assets/zh/1-8/selected.png);
            position: relative;
            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: .31rem;
                height: .24rem;
                background: url(../assets/zh/1-8/gou.png) 0 0 / 100% 100% no-repeat;
            }
        }
      }
      .errmsg {
        left: 0rem !important;
        top: 0.4rem !important;
      }
    }
    .submit_btn {
      position: absolute;
      bottom: .9rem;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      border: none;
      outline: none;
      width: 2.92rem;
      height: .87rem;
      line-height: .87rem;
      text-align: center;
      font-size: .28rem;
      color: #B04B30;
      font-weight: 700;
      cursor: pointer;
      background: url(../assets/zh/1-3/btn2.png) 0 0 / 100% 100% no-repeat;
      &:active,
      &:disabled {
        opacity: 0.8;
      }
    }
  }
  .fl_pop {
    .fl_area {
      width: 8.79rem;
      height: 7.03rem;
      background: url(../assets/zh/0/0-1/bg.png) 0 0 / 100% 100% no-repeat;
      &::before {
        top: .4rem;
        width: 6.71rem;
        height: 1.06rem;
        background: url(../assets/zh/0/0-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
      }
      .close {
        top: -.2rem;
      }
      .rule_icon {
        width: 1.17rem;
        height: 1.17rem;
        background: url(../assets/zh/0/0-1/rule_icon.png) 0 0 / 100% 100% no-repeat;
        position: absolute;
        left: -.1rem;
        top: -.1rem;
        cursor: pointer;
        transition: all ease .3s;
        &:hover {
          transform: scale(1.1);
        }
      }
      .title {
        height: .46rem;
        transform: scale(1.5);
      }
      .login_form {
        position: absolute;
        top: 1.7rem;
        left: 50%;
        transform: translateX(-50%);
        width: 6.9rem;
        height: 1.8rem;
        padding: 0.2rem 0;
        .form_item {
          margin-bottom: .1rem;
          display: flex;
          align-items: center;
          padding-right: 0.2rem;
          .label {
            flex: 1;
            font-weight: 700;
            color: #723F31;
            font-size: .22rem;
            text-align: end;
            white-space: nowrap;
          }
          input {
            border: none;
            outline: none;
            background-color: transparent;
            width: 5.5rem;
            height: .64rem;
            background: url(../assets/zh/0/0-1/ipt_bg.png) 0 0 / 100% 100% no-repeat;
            text-align: center;
            padding: 0 0.4rem;
            color: #723F31;
            font-size: .22rem;
            &::placeholder {
              color: #E4C4B1;
            }
          }
        }
      }
      .login_btn {
        position: absolute;
        bottom: 2.6rem;
        left: 50%;
        transform: translateX(-50%);
        width: 4rem;
        height: .7rem;
        border: none;
        outline: none;
        background: url(../assets/zh/0/0-1/btn_bg.png) 0 0 / 100% 100% no-repeat;
        color: #B04B30;
        font-size: .26rem;
        font-weight: 700;
        -webkit-tap-highlight-color: transparent;
        &:active {
          opacity: 0.9;
        }
      }
      .login_types {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: .9rem;
        width: 5.53rem;
        height: 1.43rem;
        display: flex;
        justify-content: space-between;
        a {
          width: 1.71rem;
          height: 100%;
          background-position: 0 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          padding-top: 1.05rem;
          text-align: center;
          color: #723F31;
          font-size: .2rem;
        }
      }
    }
  }
  .fl_error_pop {
    z-index: 201;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 6rem;
    min-height: 2.63rem;
    padding-bottom: 0.6rem;
    background: url(../assets/zh/0/0-2/bg.png) 0 0 / 100% 100% no-repeat;
    padding-top: .36rem;
    &.fl_error_pop2 {
      width: 7.06rem;
    }
    .error_tips {
      min-height: .68rem;
      padding: 0 0.6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .3rem;
      font-weight: 700;
      word-break: break-all;
      text-align: center;
      color: #fff;
      margin-bottom: .25rem;
      .error_icon {
        margin-right: .1rem;
        width: .69rem;
        height: .68rem;
        background: url(../assets/zh/0/0-2/error.png) 0 0 / 100% 100% no-repeat;
        &.error_icon2 {
          background: url(../assets/zh/0/0-3/icon.png) 0 0 / 100% 100% no-repeat;
        }
      }
    }
    button.btn {
      border: none;
      outline: none;
      display: block;
      margin: 0 auto;
      width: 2.75rem;
      height: .68rem;
      background: url(../assets/zh/0/0-2/btn_bg.png) 0 0 / 100% 100% no-repeat;
      font-size: .3rem;
      color: #B04B30;
      font-weight: 700;
      &:active {
        opacity: 0.8;
      }
    }
    .btns {
      display: flex;
      justify-content: space-between;
      padding: 0 0.5rem;
      .btn {
        min-width: 2.75rem;
        height: .7rem;
        line-height: .7rem;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        font-weight: 700;
        white-space: nowrap;
        font-size: .24rem;
        cursor: pointer;
        user-select: none;
        &:active {
          opacity: 0.8;
        }
        &.btn1 {
          color: #3051B0;
          background-image: url(../assets/zh/0/0-3/btn1.png);
        }
        &.btn2 {
          color: #B04B30;
          background-image: url(../assets/zh/0/0-3/btn2.png);
        }
      }
    }
  }
  .fl_pop {
    &.fl_pop2 {
      z-index: 300;
      background-color: transparent;
    }
    .fl_area2 {
      height: 8.5rem;
      background: url(../assets/zh/0/0-4/bg.png) 0 0 / 100% 100% no-repeat;
      .agree {
        margin: 0.7rem auto 0;
        width: 6rem;
        font-size: .2rem;
        color: #723F31;
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        line-height: 1.5;
        -webkit-tap-highlight-color: transparent;

        a {
          color: #B04B30;
          position: relative;
        }
  
        .check {
          position: relative;
          width: .26rem;
          height: .26rem;
          margin-right: .16rem;
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url(../assets/zh/1-8/notselected.png);

          &.checked {
            background-image: url(../assets/zh/1-8/selected.png);
            position: relative;

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: .31rem;
              height: .24rem;
              background: url(../assets/zh/1-8/gou.png) 0 0 / 100% 100% no-repeat;
            }
          }
        }
        .words {
          flex: 1;
        }
      }
      .select {
        width: 6.8rem;
        height: 2.2rem;
        position: absolute;
        left: 50%;
        top: 2.5rem;
        transform: translateX(-50%);
        padding: 0.1rem .5rem;
        .label {
          color: #723F31;
          font-size: .24rem;
          font-weight: 700;
          margin-bottom: .05rem;
          &.label2 {
            margin-top: .15rem;
          }
        }
        .v-select {
          height: .6rem;
        }
      }
      .btns {
        position: absolute;
        left: 50%;
        bottom: 1.2rem;
        transform: translateX(-50%);
        display: flex;
        justify-content: space-between;
        padding: 0 0.5rem;
        .btn {
          min-width: 2.75rem;
          height: .7rem;
          line-height: .7rem;
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          font-weight: 700;
          white-space: nowrap;
          font-size: .24rem;
          cursor: pointer;
          user-select: none;
          &:active {
            opacity: 0.8;
          }
          &.btn1 {
            color: #3051B0;
            background-image: url(../assets/zh/0/0-3/btn1.png);
          }
          &.btn2 {
            color: #B04B30;
            background-image: url(../assets/zh/0/0-3/btn2.png);
            margin-top: 0.04rem;
            line-height: .75rem;
          }
        }
      }
      &.fl_area3 {
        width: 8.81rem;
        height: 7.03rem;
        background: url(../assets/zh/0/0-5/bg.png) 0 0 / 100% 100% no-repeat;
        .info {
          width: 7rem;
          height: 3.8rem;
          padding-bottom: .1rem;
          margin: 0.6rem auto 0;
          overflow-y: auto;
          overflow-x: hidden;
          &::-webkit-scrollbar {
            width: .12rem;
          }
          &::-webkit-scrollbar-track {
            width: .05rem;
            border-top: none;
            border-bottom: none;
            background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
          }
          &::-webkit-scrollbar-thumb {
            width: .12rem;
            background-color: #D37966;
            border-radius: 0.2rem;
          }
          .info_p {
            padding: 0 0.5rem;
            color: #61372E;
            font-size: .24rem;
            word-break: break-all;
            margin-bottom: .1rem;
          }
          .rebateRule {
            text-align: end;
            color: #723F31;
            font-size: .24rem;
            font-weight: 700;
            padding-right: 0.1rem;
            margin-bottom: 0.1rem;
          }
          .table {
            padding: 0.2rem;
            background: url(../assets/zh/0/0-5/inner_bg.png) 0 0 / 100% 100% no-repeat;
            position: relative;

            img {
              max-width: 100%;
              height: auto;
            }
          }
        }
      }
    }
    .fl_area4 {
      z-index: 301;
      width: 9.08rem;
      height: 9.4rem;
      background: url(../assets/zh/0/0-8/bg.png) 0 0 / 100% 100% no-repeat;
      .close {
        top: -0.3rem;
        right: -0.33rem;
      }
      .title {
        height: .4rem;
        width: auto;
        max-width: 100%;
      }
      .rule_area {
        margin: 0.6rem 0 0 1.1rem;
        width: 7.2rem;
        height: 6.5rem;
        padding-right: 0.2rem;
        overflow-y: auto;
        overflow-x: hidden;
        ::v-deep p {
          font-size: .24rem;
          color: #723F31;
        }
        &::-webkit-scrollbar {
          width: .12rem;
        }
        &::-webkit-scrollbar-track {
          width: .05rem;
          border-top: none;
          border-bottom: none;
          background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
        }
        &::-webkit-scrollbar-thumb {
          width: .12rem;
          background-color: #D37966;
          border-radius: 0.2rem;
        }
        .table {
          padding: 0.2rem;
          background: url(../assets/zh/0/0-5/inner_bg.png) 0 0 / 100% 100% no-repeat;
          position: relative;
          img {
            max-width: 100%;
            height: auto;
          }
        }
      }
    }
  }
  /* 自定义Element UI Select样式 */
  .el-select {
    width: 100%;
    ::v-deep .el-input__inner {
      height: .6rem;
      border: 1px solid #FFC07F;
      font-size: .24rem;
    }
    ::v-deep .el-select__caret {
      color: #B04B30;
    }
  }
  .el-select-dropdown__item.selected {
    color: #B04B30 !important;
  }
  
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(176, 75, 48, 0.1) !important;
  }
  .yqhy_pop {
    .yq_area {
      &::before {
        display: none;
      }
      .jljl {
        width: 8.5rem;
        margin: 0.9rem auto 0;
        padding: 0;
        height: 4.2rem;
        p {
          text-align: start;
        }
      }
    }
  }
  @media screen and (max-width: 751px) {
    .navs {
      left: unset;
      transform: unset;
      width: 100%;
      height: 1.2rem;
      align-items: center;
      padding: 0 .3rem 0 .2rem;
      background: url(../assets/wap/zh/1/top_bg.png) 0 0 / 100% 100% no-repeat;
      .nav_left {
        .logo {
          width: 1.65rem;
          height: 1.11rem;
          margin: 0;
          background: url(../assets/wap/zh/1/logo.png) 0 0 / 100% 100% no-repeat;
        }
        ul {
          display: none;
        }
      }
      .nav_right {
        position: relative;
        .logout {
          font-size: .3rem;
          margin-right: 0;
          position: absolute;
          bottom: -.6rem;
          right: .1rem;
          color: #B04B30;
          border-color: #B04B30;
          &:active {
            opacity: 0.8;
          }
        }
        a {
          display: none;
        }
        button {
          border: none;
          background-color: transparent;
          width: 1.59rem;
          height: .4rem;
          background-position: 0 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        .ljyy {
          min-width: 2.1rem;
          height: .6rem;
          line-height: .6rem;
          font-size: .21rem;
        }
        .language-select {
          margin-left: 0;
          width: .76rem;
          height: .41rem;
          background: url(../assets/wap/zh/1/earth.png) 0 0 / 100% 100% no-repeat;
          span {
            display: none;
          }
          &.open {
            background: url(../assets/wap/zh/1/earth_open.png) 0 0 / 100% 100% no-repeat;
          }
          &.th,
          &.in,
          &.fi {
            height: .41rem;
            background: url(../assets/wap/zh/1/earth.png) 0 0 / 100% 100% no-repeat;
          }
        }
        .menu {
          display: block;
          margin-left: .3rem;
          width: .37rem;
          height: .31rem;
          background: url(../assets/wap/zh/1/more.png) center center / 100% 100% no-repeat;
          &.open {
            background: url(../assets/wap/zh/1/close.png) 0 0 / 100% 100% no-repeat;
          }
        }
      }
      .language-options {
        top: 1.4rem;
        right: 0;
        li {
          margin-bottom: .1rem;
        }
      }
      .menu_area {
        position: absolute;
        left: 0;
        top: 1.2rem;
        width: 100%;
        height: 100vh;
        .menu_bg {
          position: absolute;
          width: 100%;
          height: 100vh;
          top: 0;
          left: 0;
          z-index: 50;
          background-color: rgba(0,0,0,0.5);
        }
        .menu_options {
          z-index: 51;
          position: absolute;
          right: .4rem;
          top: .4rem;
          li {
            margin-bottom: 0.2rem;
            img {
              height: .34rem;
            }
          }
        } 
      }
    }
    .close {
      width: .85rem;
      height: .85rem;
    }
    .video_pop {
      .video_area {
        transform: translate(-50%,-50%) scale(0.5);
        .close {
          top: -.75rem;
          right: -.8rem;
          width: 1.7rem;
          height: 1.7rem;
        }
        .play {
          width: 1.04rem;
          height: 1.04rem;
          background: url(../assets/wap/zh/1-1/play.png) 0 0 / 100% 100% no-repeat;
        }
      }
    }
    .login_pop {
      .login_area {
        transform: translate(-50%,-50%) scale(0.75);
        .close {
          width: 1rem;
          height: 1rem;
          top: -.05rem;
          right: -.05rem;
        }
      }
    }
    .join_pop {
      .join_area {
        .close {
          width: 1rem;
          height: 1rem;
          top: 0.04rem;
          right: 0.05rem;
        }
      }
    }
    .yq_pop {
      .yq_area {
        width: 6.14rem;
        height: 5.3rem;
        .title {
          height: .26rem;
          margin: .4rem auto .3rem;
        }
        .rewards {
          width: 5.76rem;
          height: 3.14rem;
          padding-top: .2rem;
          .nums {
            width: 100%;
            justify-content: center;
            font-size: .14rem;
            .nums_area {
              width: 4.42rem;
              height: .49rem;
              line-height: .49rem;
            }
          }
          .record_btn {
            right: .26rem;
            font-size: .14rem;
          }
        }
        .btns {
          .btn {
            margin-top: 0;
            width: 2.21rem;
            height: .65rem;
            font-size: .16rem;
          }
        }
        .rule {
          font-size: .15rem;
        }
      }
    }
    .yq_pop.yq_pop2 {
      .yq_area {
        width: 7.18rem;
        height: 6.01rem;
        background: url(../assets/wap/zh/1-6/yq_bg.png) 0 0 / 100% 100% no-repeat;
        &::before {
          width: 5.3rem;
          height: .7rem;
          top: .45rem;
        }
        .close {
          top: -0.06rem;
          right: -0.12rem;
        }
        .title {
          height: .75rem;
          margin-top: .18rem;
          margin-bottom: .4rem;
        }
        .rewards {
          width: 5.95rem;
          height: 3.26rem;
          background-image: unset !important;
          position: relative;
          ul {
            width: 5.5rem;
            z-index: 2;
            position: relative;
            margin-bottom: .3rem;
            li {
              padding-top: 1.75rem;
              span {
                font-size: .16rem;
              }
            }
          }
          .nums {
            position: relative;
            z-index: 10;
          }
          .wap {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-position: 0 0;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .rule_btn {
            display: block !important;
            position: absolute;
            top: .24rem;
            left: .36rem;
            width: 1.55rem;
            height: .56rem;
            line-height: .56rem;
            text-align: center;
            font-size: .2rem;
            color: #3051B0;
            font-weight: 700;
            background: url(../assets/wap/zh/1-6/rule_bg.png) 0 0 / 100% 100% no-repeat;
            z-index: 10;
            &:active {
              opacity: 0.8;
            }
          }
          .record_btn {
            position: absolute;
            top: .24rem;
            right: .36rem;
            width: 1.55rem;
            height: .56rem;
            line-height: .56rem;
            text-align: center;
            font-size: .2rem;
            color: #B04B30;
            font-weight: 700;
            background: url(../assets/wap/zh/1-6/record_bg.png) 0 0 / 100% 100% no-repeat;
            z-index: 10;
            &:active {
              opacity: 0.8;
            }
          }
        }

        .rule {
          display: none;
        }
        .btns {
          margin-top: 0.2rem;
          .btn1 {
            line-height: .55rem;
          }
          .btn2 {
            background-size: 100% .5rem;
            line-height: .6rem;
          }
        }
      }
    }
    .rule_pop {
      .rule_area {
        width: 7.18rem;
        height: 7.96rem;
        font-size: .16rem;
        padding: 1rem 0.8rem .9rem 0.9rem;
        background: url(../assets/wap/zh/1-3/bg.png) 0 0 / 100% 100% no-repeat;
        .cont {
          height: 5.95rem;
        }
        &.news_detail_area {
          width: 7.1rem;
          height: 8rem;
          .cont {
            height: 100%;
            overflow-x: hidden;
            .tit {
              font-size: .4rem;
            }
            .news_cont {
              font-size: .24rem;
            }
          }
        }
      }
    }
    .invite_pop {
      .invite_area {
        width: 7rem;
        .close {
          right: -0.1rem;
        }
        .title {
          width: 4.8rem;
        }
        .invite_btn {
          font-size: .24rem;
        }
      }
    }
    .join_code_pop {
      .join_code_area {
        .team_code {
          width: 5rem;
          // width: 5rem;
          // height: .7rem;
          // line-height: .7rem;
          // font-size: .25rem;
        }
        .join_btn {
          font-size: .26rem;
        }
      }
    }
    .yy_pop {
      ::v-deep .yy_area {
        width: 7.18rem;
        height: 7rem !important;
        background: url(../assets/wap/zh/1-8/bg.png) 0 0 / 100% 100% no-repeat;
        &.en,
        &.in,
        &.fi {
          height: 7.2rem !important;
        }
        &.th {
          height: 6.7rem !important;
        }
        &::before {
          width: 5.3rem;
          height: .7rem;
          top: .8rem;
        }
        .title {
          height: .74rem;
          margin-top: 0.5rem;
          margin-bottom: 0.2rem;
        }
        .rewards {
          width: 5.9rem;
          height: 4.2rem;
          padding-left: 0.25rem;
          padding-right: 0.25rem;
          .w1 {
            font-size: .24rem;
          }
          .email {
            .email_ipt {
              font-size: .24rem;
              height: .52rem;
            }
          }
          .phone {
            .area_select {
              width: 1.4rem;
              padding-left: .2rem;
              font-size: .2rem;
              i {
                right: .05rem;
              }
            }
            .select_area {
              left: .1rem;
              top: 0.52rem;
              width: 30%;
              li {
                font-size: .2rem;
              }
            }
          }
          .agree {
            font-size: .16rem;
            padding: 0 0.1rem;
          }
        }
        .yuyue {
          margin: .7rem auto 0;
          font-size: .22rem;
          &.en,
          &.in {
            margin-top: .9rem;
          }
        }
        .errmsg {
          left: 0.3rem;
        }
      }
    }
    .yy_success_pop {
      .yy_success_area {
        padding-top: 0.7rem;
        width: 7.18rem;
        height: 4.48rem;
        background: url(../assets/wap/zh/1-9/bg.png) 0 0 / 100% 100% no-repeat;
        .close {
          right: -.12rem;
          top: -.08rem;
        }
        .p2 {
          width: 5.26rem;
          height: auto;
          position: absolute;
          bottom: 1.1rem;
          left: 50%;
          transform: translateX(-50%);
          &.in {
            transform: translate(-50%,-0.2rem);
          }
        }
        .p3 {
          display: none;
        }
      }
    }
    .win_pop {
      .win_area {
        width: 7.18rem;
        height: 6.01rem;
        padding-top: 0.8rem;
        &::before {
          top: -0.8rem;
        }
        .close {
          right: 0.05rem;
          top: 0.05rem;
        }
        .title {
          height: .7rem;
        }
        p {
          padding: 0 1.2rem;
          font-size: .24rem;
          margin-top: .6rem;
          text-align: start;
          &.en {
            margin-top: .6rem;
          }
        }
      }
    }
    .chance_pop {
      .chance_area {
        width: 7.18rem;
        height: 9.49rem;
        background: url(../assets/wap/zh/3-4/bg.png) 0 0 / 100% 100% no-repeat;
        &::before {
          width: 6.61rem;
          height: .86rem;
          background: url(../assets/wap/zh/3-4/tit_bg.png) 0 0 / 100% 100% no-repeat;
        }
        .title {
          height: .9rem;
          margin: 0.4rem auto 0.8rem;
        }
        .rewards {
          width: 5.14rem;
          padding: 0;
          .chance {
            padding-right: 0.2rem;
            width: 100%;
            background-size: 9.18rem .76rem;
            border-radius: 1rem;
            overflow: hidden;
            p {
              font-size: .34rem;
            }
            .btn {
              display: none;
            }
          }
          .btn {
            display: block;
            margin: .08rem auto;
            width: 3.99rem;
            height: .69rem;
            line-height: .65rem;
            text-align: center;
            background: url(../assets/wap/zh/3-4/btn_bg.png) 0 0 / 100% 100% no-repeat;
            color: #B04B30;
            font-size: .3rem;
            font-weight: 700;
            &:active, &.disable {
              opacity: 0.8;
            }
          }
        }
      }
    }
    .sw_pop {
      .yq_area {
        width: 7.18rem;
        height: 6.01rem;
        background: url(../assets/wap/zh/3-5/bg.png) 0 0 / 100% 100% no-repeat;
        .title {
          height: .9rem;
          margin: 0rem auto 0.3rem;
        }
        .win_name {
          margin-bottom: 0.1rem;
        }
        .form {
          .form_item {
            width: 100%;
            padding: 0 0.2rem;
            input {
              width: 4.5rem;
            }
          }
          .agree {
            padding-left: 0.4rem;
            font-size: .16rem;
          }
        }
        .submit_btn {
          bottom: .55rem;
          width: 3.99rem;
          height: .69rem;
          line-height: .69rem;
          background: url(../assets/wap/zh/3-5/btn_bg.png) 0 0 / 100% 100% no-repeat;
          -webkit-tap-highlight-color: transparent;
        }
      }
    }

    .fl_pop {
      .fl_area {
        width: 8.79rem;
        height: 7.03rem;
        background: url(../assets/zh/0/0-1/bg.png) 0 0 / 100% 100% no-repeat;
        transform: translate(-50%,-50%) scale(0.8);
        transform-origin: center center;
        &::before {
          top: .4rem;
          width: 6.71rem;
          height: 1.06rem;
          background: url(../assets/zh/0/0-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
        }
        .close {
          top: -.05rem;
          right: -.05rem;
        }
        .rule_icon {
          width: 1.17rem;
          height: 1.17rem;
          background: url(../assets/zh/0/0-1/rule_icon.png) 0 0 / 100% 100% no-repeat;
          position: absolute;
          left: -.1rem;
          top: -.1rem;
          cursor: pointer;
          transition: all ease .3s;
          -webkit-tap-highlight-color: transparent;
          &:hover {
            transform: scale(1.1);
          }
        }
        .title {
          height: .46rem;
        }
        .login_form {
          position: absolute;
          top: 1.7rem;
          left: 50%;
          transform: translateX(-50%);
          width: 6.9rem;
          height: 1.8rem;
          padding: 0.2rem 0;
          .form_item {
            margin-bottom: .1rem;
            display: flex;
            align-items: center;
            padding-right: 0.2rem;
            .label {
              flex: 1;
              font-weight: 700;
              color: #723F31;
              font-size: .22rem;
              text-align: end;
            }
            input {
              border: none;
              outline: none;
              background-color: transparent;
              width: 5.5rem;
              height: .64rem;
              background: url(../assets/zh/0/0-1/ipt_bg.png) 0 0 / 100% 100% no-repeat;
              text-align: center;
              padding: 0 0.4rem;
              color: #723F31;
              font-size: .22rem;
              &::placeholder {
                color: #E4C4B1;
              }
            }
          }
        }
        .login_btn {
          position: absolute;
          bottom: 2.6rem;
          left: 50%;
          transform: translateX(-50%);
          width: 4rem;
          height: .7rem;
          border: none;
          outline: none;
          background: url(../assets/zh/0/0-1/btn_bg.png) 0 0 / 100% 100% no-repeat;
          color: #B04B30;
          font-size: .26rem;
          font-weight: 700;
          &:active {
            opacity: 0.9;
          }
        }
        .login_types {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: .9rem;
          width: 5.53rem;
          height: 1.43rem;
          display: flex;
          justify-content: space-between;
          a {
            width: 1.71rem;
            height: 100%;
            background-position: 0 0;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding-top: 1.05rem;
            text-align: center;
            color: #723F31;
            font-size: .2rem;
          }
        }
      }
    }
    .fl_pop {
      &.fl_pop2 {
        z-index: 300;
        background-color: transparent;
      }
      .fl_area2 {
        height: 8.2rem;
        background: url(../assets/zh/0/0-4/bg.png) 0 0 / 100% 100% no-repeat;
        .agree {
          margin: 0.7rem auto 0;
          width: 6rem;
          font-size: .2rem;
          color: #723F31;
          display: flex;
          align-items: center;
          cursor: pointer;
          user-select: none;
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          line-height: 1.5;
          -webkit-tap-highlight-color: transparent;

          a {
            color: #B04B30;
            position: relative;
          }
        
          .check {
            position: relative;
            width: .26rem;
            height: .26rem;
            margin-right: .16rem;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url(../assets/zh/1-8/notselected.png);

            &.checked {
              background-image: url(../assets/zh/1-8/selected.png);
              position: relative;

              &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: .31rem;
                height: .24rem;
                background: url(../assets/zh/1-8/gou.png) 0 0 / 100% 100% no-repeat;
              }
            }
          }
          .words {
            flex: 1;
          }
        }
        .select {
          width: 6.8rem;
          height: 2.2rem;
          position: absolute;
          left: 50%;
          top: 2.5rem;
          transform: translateX(-50%);
          padding: 0.1rem .5rem;
          .label {
            color: #723F31;
            font-size: .24rem;
            font-weight: 700;
            margin-bottom: .05rem;
            &.label2 {
              margin-top: .15rem;
            }
          }
          .v-select {
            height: .6rem;
          }
        }
        .btns {
          position: absolute;
          left: 50%;
          bottom: 1rem;
          transform: translateX(-50%);
          display: flex;
          justify-content: space-between;
          padding: 0 0.5rem;
          .btn {
            min-width: 2.75rem;
            height: .7rem;
            line-height: .7rem;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            text-align: center;
            font-weight: 700;
            white-space: nowrap;
            font-size: .24rem;
            cursor: pointer;
            user-select: none;
            &:active {
              opacity: 0.8;
            }
            &.btn1 {
              color: #3051B0;
              background-image: url(../assets/zh/0/0-3/btn1.png);
            }
            &.btn2 {
              color: #B04B30;
              background-image: url(../assets/zh/0/0-3/btn2.png);
              margin-top: 0.05rem;
            }
          }
        }
        &.fl_area3 {
          width: 8.81rem;
          height: 7.03rem;
          background: url(../assets/zh/0/0-5/bg.png) 0 0 / 100% 100% no-repeat;
          .info {
            width: 7rem;
            height: 3.8rem;
            margin: 0.6rem auto 0;
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar {
              width: .12rem;
            }
            &::-webkit-scrollbar-track {
              width: .05rem;
              border-top: none;
              border-bottom: none;
              background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
            }
            &::-webkit-scrollbar-thumb {
              width: .12rem;
              background-color: #D37966;
              border-radius: 0.2rem;
            }
            .info_p {
              padding: 0 0.5rem;
              color: #61372E;
              font-size: .24rem;
              word-break: break-all;
              margin-bottom: .1rem;
            }
            .rebateRule {
              text-align: end;
              color: #723F31;
              font-size: .24rem;
              font-weight: 700;
              padding-right: 0.1rem;
              margin-bottom: 0.1rem;
            }
            .table {
              padding: 0.2rem;
              background: url(../assets/zh/0/0-5/inner_bg.png) 0 0 / 100% 100% no-repeat;
              position: relative;
              img {
                max-width: 100%;
                height: auto;
              }
            }
          }
        }
      }
      .fl_area4 {
        z-index: 301;
        width: 9.08rem;
        height: 9.4rem;
        background: url(../assets/zh/0/0-8/bg.png) 0 0 / 100% 100% no-repeat;
        .close {
          top: -0.1rem;
          right: -0.1rem;
        }
        .title {
          height: .4rem;
          width: auto;
          max-width: 100%;
        }
        .rule_area {
          margin: 0.6rem 0 0 1.1rem;
          width: 7.2rem;
          height: 6.5rem;
          padding-right: 0.2rem;
          overflow-y: auto;
          overflow-x: hidden;
          ::v-deep p {
            font-size: .24rem;
            color: #723F31;
          }
          &::-webkit-scrollbar {
            width: .12rem;
          }
          &::-webkit-scrollbar-track {
            width: .05rem;
            border-top: none;
            border-bottom: none;
            background: url(../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
          }
          &::-webkit-scrollbar-thumb {
            width: .12rem;
            background-color: #D37966;
            border-radius: 0.2rem;
          }
          .table {
            padding: 0.2rem;
            background: url(../assets/zh/0/0-5/inner_bg.png) 0 0 / 100% 100% no-repeat;
            position: relative;
            img {
              max-width: 100%;
              height: auto;
            }
          }
        }
      }
    }
    .yqhy_pop {
      .yq_area {
        width: 7.2rem;
        &::before {
          display: none;
        }
        .close {
          top: -0.05rem;
        }
        .jljl {
          width: 5.5rem;
          margin: 0.9rem auto 0;
          padding: 0;
          height: 3.5rem;
          p {
            text-align: start;
          }
        }
      }
    }
  }
</style>
